import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify'; // Make sure you have react-toastify installed & set up

const ShopcategoryAdd = () => {
  const navigate = useNavigate();

  const initialFormState = {
    discount: "",
    title:"",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [shop_category_image, setshop_category_image] = useState(null);
  const [brand_logo, setbrand_logo] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);

  // Handle text input (discount)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle file inputs (both image and logo)
  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    if (type === 'image') {
      setshop_category_image(file);
      setPreviewImage(URL.createObjectURL(file));
    } else if (type === 'logo') {
      setbrand_logo(file);
      setPreviewLogo(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const apiFormData = new FormData();
    apiFormData.append('discount', formData.discount);
    apiFormData.append('title', formData.title);
    if (shop_category_image) apiFormData.append('rising_star_image', shop_category_image);
    if (brand_logo) apiFormData.append('brand_logo', brand_logo);

    try {
      const response = await axios.post(
        'https://cyberathon.com/multivendor/index.php/Api/Master_controller/shop_categories',
        apiFormData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.success === '1') {
        toast.success(response.data.message || 'Rising Star added successfully!');
        // Reset form
        setFormData(initialFormState);
        setshop_category_image(null);
        setbrand_logo(null);
        setPreviewImage(null);
        setPreviewLogo(null);
        window.location.reload();
        navigate('/ShopByCategory');
      } else {
        toast.error(response.data.message || 'Failed to add Rising Star');
      }
    } catch (error) {
      console.error('API Error:', error);
      toast.error('Something went wrong!');
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Add Product</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><a href="#">Product</a></li>
            <li className="breadcrumb-item active">Add</li>
          </ol>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">New Product</h4>
            </div>
            <div className="card-body row">
              {/* Main Image */}
              <div className="col-lg-6 mb-3">
                <label className="form-label">Main Image</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'image')}
                  required
                />
                {previewImage && (
                  <img src={previewImage} alt="Preview" height="80" className="mt-2" />
                )}
              </div>

              {/* Brand Logo */}
              <div className="col-lg-6 mb-3">
                <label className="form-label">Brand Logo</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'logo')}
                  required
                />
                {previewLogo && (
                  <img src={previewLogo} alt="Logo Preview" height="80" className="mt-2" />
                )}
              </div>

              {/* discount */}
              <div className="col-lg-6 mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Title"
                  required
                />
              </div>

              {/* discount */}
              <div className="col-lg-6 mb-3">
                <label className="form-label">discount</label>
                <input
                  type="text"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="e.g., Up To 50% Off"
                  required
                />
              </div>
            </div>

            <div className="card-footer">
              <button type="submit" className="btn btn-primary">
                Save Product
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ShopcategoryAdd;